import './FabModal.f8045d8687592e15d4240bd8978e9188.css';
export default {"fabModal":"_fabModal_pa7gq_1","button":"_button_pa7gq_1"};